import { render, staticRenderFns } from "./NonFormularyRequests.html?vue&type=template&id=410f821b&external"
import script from "./NonFormularyRequests.js?vue&type=script&lang=js&external"
export * from "./NonFormularyRequests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports